import dayjs from "dayjs"
import { useTranslation } from "react-i18next"
import { TimePeriod } from "../@client/Theasoft_ApiServer_Activities"

export function useTimePeriod() {
  const { t } = useTranslation("app_server")
  const getTimePeriod = (value: TimePeriod) => {
    const start =
      value.start !== null ? dayjs(value.start).format("LT") : undefined
    const end = value.end !== null ? dayjs(value.end).format("LT") : undefined
    if (start && end && start === end) {
      return start
    }
    if (start && end) {
      return ` ${start} - ${end}`
    }

    if (start) {
      return start
    }
    if (end) {
      return `${t("To_LowerCase")} ${end}`
    }
    return ""
  }
  return { getTimePeriod }
}
